import { styled } from "../../config/stiches.config";

export const MenuFieldItem = styled("button", {
  color: "$colors$gray700",
  fontFamily: "$inter",
  backgroundColor: "transparent",
  py: "$space$2",
  px: "$space$4",
  cursor: "pointer",
  fontSize: "$2",
  lineHeight: "$2",
  fontWeight: "$2",
  outline: "none",
  whiteSpace: "nowrap",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  textAlign: "left",
  variants: {
    active: {
      true: {
        backgroundColor: "$colors$teal100",
        color: "$colors$teal600",
        ["&:hover"]: {
          backgroundColor: "$colors$teal100",
        },
      },
      false: {
        ["svg"]: {
          color: "$gray400",
        },
      },
    },
    hoverType: {
      constructive: {
        ["&:hover"]: {
          backgroundColor: "$colors$teal100",
          color: "$colors$teal600",
        },
        ["&:focus"]: {
          backgroundColor: "$colors$teal100",
          color: "$colors$teal600",
        },
      },
      destructive: {
        backgroundColor: "transparent",
        ["&:hover"]: {
          color: "$colors$red600",
          backgroundColor: "transparent",
        },
      },
      defaultGray: {
        color: "$gray700",
        ["&:hover"]: {
          backgroundColor: "$colors$gray100",
          color: "$colors$gray900",
        },
        ["&:focus"]: {
          backgroundColor: "$colors$gray100",
          color: "$colors$gray900",
        },
      },
    },
    topBorder: {
      true: {
        borderTop: "1px solid $colors$gray200",
      },
    },
  },
  compoundVariants: [
    {
      active: true,
      hoverType: "destructive",
      css: {
        backgroundColor: "transparent",
        color: "$colors$red600",
        ["&:hover"]: {
          color: "$colors$red600",
          backgroundColor: "transparent",
        },
      },
    },
  ],
  defaultVariants: {
    hoverType: "constructive",
    active: false,
  },
});

export const MenuContainer = styled("div", {
  position: "relative",
  display: "inline-block",
  textAlign: "left",
});

export const MenuItemContainer = styled("div", {
  transformOrigin: "top right",
  position: "absolute",
  display: "flex",
  flexDirection: "column",
  right: "0px",
  mt: "$space$2",
  width: "100%",
  minWidth: "224px",
  maxWidth: "224px",
  boxShadow: "$shadows$shadow-md",
  borderRadius: "$2",
  background: "White",
  zIndex: 500,
  py: "0",
  overflow: "hidden",
  ["&:focus"]: {
    outline: "none",
  },
  variants: {
    size: {
      default: {
        minWidth: "224px",
        maxWidth: "224px",
      },
      small: {
        minWidth: "175px",
        maxWidth: "175px",
      },
      xsmall: {
        minWidth: "125px",
        maxWidth: "125px",
      },
    },
  },
  defaultVariants: {
    size: "default",
  },
});

/**
 *  $$ringInset: '1px',
    $$offsetWidth: '2px',
    $$ringColor: 'Black',
    $$offsetShadow: '$$ringInset 0 0 0 $$offsetWidth $$ringColor',
    $$ringShadow: '$$ringInset 0 0 0 calc(1px + $$offsetWidth) $$ringColor',
 */
